module.exports = __webpack_public_path__ + "static/media/ra100.68d4b83f.svg";